/* ═══════════════════════════════════════════════
   Assurance of Panacea Biotec — Shared JS
   assets/assurance.js
   Loaded once via layout or the first section that needs it.
═══════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ════════════════════════════════
     CAROUSEL ENGINE
     Usage: data-carousel="trackId"
            data-prev="prevBtnId"
            data-next="nextBtnId"
            data-dots="dotsId"
     on the wrapping element.
     Or call window.AP.initCarousel(cfg) directly.
  ════════════════════════════════ */
  function initCarousel(cfg) {
    var track   = document.getElementById(cfg.trackId);
    var prevBtn = document.getElementById(cfg.prevId);
    var nextBtn = document.getElementById(cfg.nextId);
    var dotsEl  = document.getElementById(cfg.dotsId);
    if (!track || !prevBtn || !nextBtn || !dotsEl) return;

    var cards = track.querySelectorAll('.ap-c-card');
    if (!cards.length) return;
    var index = 0;

    function visibleCount() {
      var w = window.innerWidth;
      if (w <= 600)  return 1;
      if (w <= 1024) return 2;
      return 3;
    }
    function totalSlides() { return Math.ceil(cards.length / visibleCount()); }

    function buildDots() {
      dotsEl.innerHTML = '';
      for (var i = 0; i < totalSlides(); i++) {
        var d = document.createElement('button');
        d.className = 'ap-carousel-dot' + (i === index ? ' active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsEl.appendChild(d);
      }
    }

    function update() {
      var vc    = visibleCount();
      var cardW = cards[0].offsetWidth;
      track.style.transform = 'translateX(-' + (index * vc * (cardW + 20)) + 'px)';
      dotsEl.querySelectorAll('.ap-carousel-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === index);
      });
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index >= totalSlides() - 1;
    }

    function goTo(i) { index = Math.max(0, Math.min(i, totalSlides() - 1)); update(); }
    prevBtn.addEventListener('click', function () { goTo(index - 1); });
    nextBtn.addEventListener('click', function () { goTo(index + 1); });

    /* Swipe */
    var tx = 0;
    track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   function (e) {
      var dx = tx - e.changedTouches[0].clientX;
      if (Math.abs(dx) > 40) goTo(index + (dx > 0 ? 1 : -1));
    });

    window.addEventListener('resize', function () { index = 0; buildDots(); update(); });
    buildDots();
    update();
  }

  /* ════════════════════════════════
     AUTO-INIT: find all [data-ap-carousel] wrappers
  ════════════════════════════════ */
  function initAllCarousels() {
    document.querySelectorAll('[data-ap-carousel]').forEach(function (wrap) {
      initCarousel({
        trackId: wrap.dataset.apCarousel,
        prevId:  wrap.dataset.apPrev,
        nextId:  wrap.dataset.apNext,
        dotsId:  wrap.dataset.apDots
      });
    });
  }

  /* ════════════════════════════════
     SCROLL FADE-UP
  ════════════════════════════════ */
  function initFadeUp() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.ap-fade-up').forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.ap-fade-up').forEach(function (el) { observer.observe(el); });
  }

  /* ════════════════════════════════
     BAN TABS (Safety section)
     Works with data-ap-tab="id" on buttons
     and data-ap-tab-panel="id" on panels.
  ════════════════════════════════ */
  function initBanTabs() {
    document.querySelectorAll('[data-ap-tab-group]').forEach(function (group) {
      group.querySelectorAll('[data-ap-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.apTab;
          group.querySelectorAll('[data-ap-tab]').forEach(function (b)   { b.classList.remove('active'); });
          group.querySelectorAll('[data-ap-tab-panel]').forEach(function (p) { p.classList.remove('active'); });
          btn.classList.add('active');
          var panel = group.querySelector('[data-ap-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('active');
        });
      });
    });
  }

  /* ════════════════════════════════
     NAV HIGHLIGHT (in ap-hero-nav section)
  ════════════════════════════════ */
  function initNavHighlight() {
    var navLinks = document.querySelectorAll('.ap-nav-link');
    if (!navLinks.length) return;
    var anchors = Array.from(document.querySelectorAll('[data-ap-anchor]'));
    window.addEventListener('scroll', function () {
      var cur = '';
      anchors.forEach(function (s) { if (window.scrollY >= s.offsetTop - 90) cur = s.id; });
      navLinks.forEach(function (a) {
        a.style.color = a.getAttribute('href') === '#' + cur ? 'var(--ap-primary)' : '';
      });
    }, { passive: true });
  }

  /* ════════════════════════════════
     MOBILE MENU (in ap-hero-nav section)
  ════════════════════════════════ */
  function initMobileMenu() {
    var btn  = document.getElementById('ap-hamburger');
    var menu = document.getElementById('ap-mobile-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () { menu.classList.toggle('open'); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { menu.classList.remove('open'); });
    });
  }

  /* ════════════════════════════════
     BOOT
  ════════════════════════════════ */
  function boot() {
    initAllCarousels();
    initFadeUp();
    initBanTabs();
    initNavHighlight();
    initMobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Expose for Shopify theme editor live reloads */
  window.AP = window.AP || {};
  window.AP.initCarousel  = initCarousel;
  window.AP.initFadeUp    = initFadeUp;
  window.AP.initBanTabs   = initBanTabs;
  window.AP.boot          = boot;

  document.addEventListener('shopify:section:load', boot);

})();
